/**
 * KoT score mapping for coach result wizard (mirrors iOS KingOfTableRoundUI).
 */

export function winnerScoreForLoser(loser, target = 11, winBy = 2) {
  const deuceFloor = Math.max(0, target - winBy);
  if (loser >= deuceFloor) return loser + winBy;
  return target;
}

export function fullSetScoresForSubmit(
  winnerIsPlayerA,
  loserScore,
  target = 11,
  winBy = 2
) {
  const winner = winnerScoreForLoser(loserScore, target, winBy);
  if (winnerIsPlayerA) {
    return { scoreA: winner, scoreB: loserScore };
  }
  return { scoreA: loserScore, scoreB: winner };
}

export function goldenPointWinnerScores(winnerIsPlayerA, winnerScore) {
  const winner = Math.max(1, winnerScore);
  const loser = Math.max(0, winner - 1);
  if (winnerIsPlayerA) {
    return { scoreA: winner, scoreB: loser };
  }
  return { scoreA: loser, scoreB: winner };
}

export function defaultLoserScore(target = 11) {
  return Math.max(0, target - 2);
}

/**
 * Stop-on-lead entry after round stop: winner at set target, adjust loser stepper.
 */
export function stopLoserOnlyScores({
  winnerIsPlayerA,
  loserScore,
  goldenPoint,
  target = 11,
  winBy = 2,
  useWinnerAtSetTarget = true,
  snapshotScoreA = 0,
  snapshotScoreB = 0,
}) {
  if (goldenPoint) {
    const winnerVal =
      useWinnerAtSetTarget && loserScore === defaultLoserScore(target)
        ? target
        : Math.max(1, loserScore);
    return goldenPointWinnerScores(winnerIsPlayerA, winnerVal);
  }
  if (useWinnerAtSetTarget) {
    return fullSetScoresForSubmit(winnerIsPlayerA, loserScore, target, winBy);
  }
  if (winnerIsPlayerA) {
    return { scoreA: snapshotScoreA, scoreB: loserScore };
  }
  return { scoreA: loserScore, scoreB: snapshotScoreB };
}

export function inferWinnerSideFromScores(scoreA, scoreB) {
  const a = Number(scoreA);
  const b = Number(scoreB);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  if (a > b) return "A";
  if (b > a) return "B";
  return null;
}

export function getCoachResultEntryMode(submitConfig) {
  const mode = submitConfig?.kot_mode || submitConfig?.match_winner_mode;
  const normalized =
    mode === "FULL_SET" ? "FULL_SET" : "STOP_SCORE_LEAD";
  if (normalized === "FULL_SET") return "full_set_dual";
  if (submitConfig?.round_state === "STOP_REQUESTED") {
    return "stop_loser_only";
  }
  return "full_set_dual";
}
